import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["table", "pageInfo"];

  connect() {
    console.log('Results controller connected');
    console.log('Targets:', this.hasTableTarget, this.hasPageInfoTarget);
    
    this.page = 1;
    this.perPage = 10;
    this.category = "Elite Men";

    // mock data (заменишь на API)
    this.ridersData = this.generateMockData();
    console.log('Data generated:', this.ridersData);

    this.render();
  }

  changeCategory(e) {
    this.category = e.currentTarget.dataset.category;
    this.page = 1;
    this.render();
  }

  next() {
    this.page++;
    this.render();
  }

  prev() {
    if (this.page > 1) {
      this.page--;
      this.render();
    }
  }

  render() {
    const filtered = this.ridersData[this.category] || [];
    const start = (this.page - 1) * this.perPage;
    const pageItems = filtered.slice(start, start + this.perPage);

    this.tableTarget.innerHTML = pageItems
      .map((r, i) => {
        const position = start + i + 1;

        return `
        <tr class="${this.rowClass(position)} border-b border-white/5">
          <td class="px-4 py-3 font-semibold">${position}</td>
          <td class="px-4 py-3">${r.name}</td>
          <td class="px-4 py-3 opacity-70">${r.team}</td>
          <td class="px-4 py-3 text-right tabular-nums">${r.time}</td>
        </tr>
      `;
      })
      .join("");

    this.pageInfoTarget.innerText = `Page ${this.page}`;
  }

  rowClass(pos) {
    if (pos === 1) return "bg-yellow-400/20 border-l-4 border-yellow-400";
    if (pos === 2) return "bg-white/10";
    if (pos === 3) return "bg-white/5";
    return "";
  }

  generateMockData() {
    const maleNames = [
      "Александр Иванов", "Дмитрий Петров", "Сергей Сидоров", "Андрей Козлов",
      "Михаил Новиков", "Иван Морозов", "Алексей Волков", "Артем Соколов",
      "Владимир Лебедев", "Максим Семенов", "Денис Егоров", "Павел Романов",
      "Кирилл Васильев", "Роман Никитин", "Виктор Орлов", "Олег Кузнецов"
    ];

    const femaleNames = [
      "Анна Смирнова", "Мария Кузнецова", "Елена Попова", "Ольга Соколова",
      "Наталья Лебедева", "Ирина Козлова", "Татьяна Новикова", "Екатерина Морозова",
      "Светлана Петрова", "Юлия Волкова", "Дарья Васильева", "Алина Зайцева"
    ];

    const juniorNames = [
      "Артем Смирнов", "Данил Попов", "Егор Соколов", "Тимур Козлов",
      "Никита Лебедев", "Марк Новиков", "Матвей Морозов", "Савелий Петров",
      "София Иванова", "Виктория Кузнецова", "Полина Волкова", "Дарья Семенова"
    ];

    const teams = [
      "Almaty Riders", "Steppe Wolves", "Mountain Kings", "Trail Blazers",
      "Pro Team KZ", "Nomad Cycling", "Epic Riders", "Велоклуб Алматы",
      "Canyon Team", "Scott Factory", "Независимый", "Жеке спортшы"
    ];

    const makeRiders = (names) =>
      names.map((name, i) => {
        const baseMinutes = 30 + Math.floor(i / 2);
        const seconds = (10 + i * 3) % 60;
        return {
          name: name,
          team: teams[i % teams.length],
          time: `01:${baseMinutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`,
        };
      });

    return {
      "Elite Men": makeRiders(maleNames),
      "Elite Women": makeRiders(femaleNames),
      "Junior": makeRiders(juniorNames)
    };
  }
}
